module.exports = __webpack_public_path__ + "static/media/couple.0beb3248.png";